import { NgModuleRef } from '@angular/core';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatChipsModule } from '@angular/material/chips';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { PortalModule } from '@angular/cdk/portal';
import { OverlayModule } from '@angular/cdk/overlay';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatDividerModule } from '@angular/material/divider';
import { MatMenuModule } from '@angular/material/menu';
import { MatListModule } from '@angular/material/list';
import { MatGridListModule } from '@angular/material';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { DynamicOutletRegistryService, RegistryItem } from '@awp/dynamic-outlet';
import * as fromWidgets from './widgets';
var MATERIAL_MODULES = [
    MatToolbarModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatIconModule,
    MatAutocompleteModule,
    MatChipsModule,
    MatDatepickerModule,
    MatCheckboxModule,
    MatSidenavModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatSlideToggleModule,
    MatDialogModule,
    MatExpansionModule,
    MatCardModule,
    MatDividerModule,
    PortalModule,
    OverlayModule,
    MatMenuModule,
    MatListModule,
    MatGridListModule,
    MatProgressBarModule
];
export var COMPONENT_REGISTER = [
    {
        componentName: 'NavMenuWidgetComponent',
        componentType: fromWidgets.NavMenuWidgetComponent
    }
];
var ɵ0 = {};
var CommonUiModule = /** @class */ (function () {
    function CommonUiModule(moduleRef, dynamicOutletRegistry) {
        dynamicOutletRegistry.register(CommonUiModule.name, COMPONENT_REGISTER, moduleRef);
    }
    return CommonUiModule;
}());
export { CommonUiModule };
export { ɵ0 };
